
export default {
  download: '下载APP',
}
